import React, { useState } from 'react';
import '../../../../assests/css/admin/CustomerManagement/AddCustomerModal/AddCustomerModal.css';

const AddCustomerModal = ({ isOpen, onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    tier: 'Standard',
    password: '',
    address: ''
  });

  const handleSubmit = () => {
    if (formData.fullName && formData.email && formData.phone) {
      onAdd(formData);
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        tier: 'Standard',
        password: '',
        address: ''
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="add-modal-overlay">
      <div className="add-modal-content">
        <div className="add-modal-header">
          <div className="add-modal-title-section">
            <div className="add-modal-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="#2563eb" strokeWidth="2"/>
                <circle cx="9" cy="7" r="4" stroke="#2563eb" strokeWidth="2"/>
                <line x1="19" y1="8" x2="19" y2="14" stroke="#2563eb" strokeWidth="2"/>
                <line x1="22" y1="11" x2="16" y2="11" stroke="#2563eb" strokeWidth="2"/>
              </svg>
            </div>
            <div>
              <h2 className="add-modal-title">Add New Customer</h2>
              <p className="add-modal-subtitle">Enter details to create a new customer account.</p>
            </div>
          </div>
          <button className="add-modal-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="add-modal-body">
          <div className="add-form-row">
            <div className="add-form-group">
              <label>Full Name</label>
              <input
                type="text"
                placeholder="John Doe"
                value={formData.fullName}
                onChange={(e) => setFormData({...formData, fullName: e.target.value})}
              />
            </div>
            <div className="add-form-group">
              <label>Email Address</label>
              <input
                type="email"
                placeholder="john@example.com"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
            </div>
          </div>

          <div className="add-form-row">
            <div className="add-form-group">
              <label>Phone Number</label>
              <input
                type="tel"
                placeholder="+1 (555) 000-0000"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
              />
            </div>
            <div className="add-form-group">
              <label>Customer Tier</label>
              <select
                value={formData.tier}
                onChange={(e) => setFormData({...formData, tier: e.target.value})}
              >
                <option>Standard</option>
                <option>VIP</option>
                <option>Premium</option>
              </select>
            </div>
          </div>

          <div className="add-form-group">
            <label>Password <span className="add-optional">(Optional)</span></label>
            <input
              type="password"
              placeholder="Leave empty to auto-generate"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
            />
          </div>

          <div className="add-form-group">
            <label>Shipping Address</label>
            <textarea
              placeholder="Street address, city, state, zip code..."
              value={formData.address}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
              rows="4"
            />
          </div>

          <div className="add-modal-footer">
            <button className="add-cancel-btn" onClick={onClose}>Cancel</button>
            <button className="add-submit-btn" onClick={handleSubmit}>+ Add Customer</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCustomerModal;